import {isMobile} from '../helpers';
import {panelsTransition} from '../lib/animations-new';

const toggleQuestion = (event) => {
  let question = event.target.closest('.park-new__service-item');

  question.classList.toggle('park-new__service-item--hidden');
  $(question.querySelector('.park-new__service-item-answer')).slideToggle('slow');
};

const handleQuestionClick = () => {
  const buttons = document.getElementsByClassName('park-new__service-item-block');

  Array.from(buttons).forEach((button) =>
    button.addEventListener('click', (event) => toggleQuestion(event))
  );
};

const toggleRules = (event) => {
  let rule = event.target.closest('.park-new__rules-item');

  rule.classList.toggle('park-new__rules-item--hidden');
  $(rule.querySelector('.park-new__rules-item-list')).slideToggle('slow');
};

const handleRulesClick = () => {
  const buttons = document.getElementsByClassName('park-new__rules-item-block');

  Array.from(buttons).forEach((button) =>
    button.addEventListener('click', (event) => toggleRules(event))
  );
};

const handleTabsClick = (hiddenTabClass, activeButtonClass, buttons, tabs) => {
  const updateTabs = (buttonIndex) => {
    Array.from(tabs).forEach((tab, tabIndex) => {
      if (buttonIndex === tabIndex) {
        tab.classList.remove(hiddenTabClass);
        buttons[tabIndex].classList.add(activeButtonClass);
      } else {
        tab.classList.add(hiddenTabClass);
        buttons[tabIndex].classList.remove(activeButtonClass);
      }
    });
  };

  Array.from(buttons).forEach((button, index) => {
    button.addEventListener('click', () => updateTabs(index));
  });
};

const handleTabsClickClassesTop = () => {
  const hiddenTabClass = 'park-new__objects-cards--hidden';
  const activeButtonClass = 'park-new__objects-info-item--active';

  const buttons = document.getElementsByClassName('park-new__objects-info-item ');
  const tabs = document.getElementsByClassName('park-new__objects-cards');

  handleTabsClick(hiddenTabClass, activeButtonClass, buttons, tabs);
};

const handleTabsClickClassesBottom = () => {
  const hiddenTabClass = 'park-new__way-content-wrapper--hidden';
  const activeButtonClass = 'park-new__way-tabs-item--active';

  const buttons = document.getElementsByClassName('park-new__way-tabs-item');
  const tabs = document.getElementsByClassName('park-new__way-content-wrapper');

  handleTabsClick(hiddenTabClass, activeButtonClass, buttons, tabs);
};

const handleTabsClickCalendar = () => {
  const hiddenTabClass = 'park-new__calendar-wrapper--hidden';
  const activeButtonClass = 'park-new__calendar-tabs-button--active';

  const buttons = document.getElementsByClassName('park-new__calendar-tabs-button');
  const tabs = document.getElementsByClassName('park-new__calendar-wrapper');

  handleTabsClick(hiddenTabClass, activeButtonClass, buttons, tabs);
};

const ParkNewComponent = () => {
  handleQuestionClick();
  handleTabsClickClassesTop();
  handleTabsClickClassesBottom();
  handleTabsClickCalendar();
  handleRulesClick();

  if (!isMobile()) {
    panelsTransition('.park-new__place-container', '.park-new__place');
    panelsTransition('.park-new__numbers-container', '.park-new__numbers', true);
  }
};

export const ParkNew = () => {
  $(document).ready(() => ParkNewComponent());
};
